import React, { FC } from 'react';

import ErrorBoundary from '@buyside/components/presentation/ErrorBoundary/errorBoundary';
import SubscribePage from '@buyside/components/presentation/SubscribePage/subscribePage';

const SubscribePageRoot: FC<{ isRetail: string }> = ({ isRetail }) => {
  return (
    <ErrorBoundary pageName="the available payment options">
      <SubscribePage isRetail={isRetail === 'true'} />
    </ErrorBoundary>
  );
};

export default SubscribePageRoot;
